import * as React from "react";
import { withStyles } from "@mui/styles";
import { Typography,Box } from "@mui/material";
import { fonts } from "../../themes/themes";
const styles = {
    box: {
        backgroundColor: "#FAFAFA",
        borderRadius: "0.6em",
        padding: "0.5em",
        display: "flex",
        marginBottom: "1em",
    },
    title: {
        flex: 1,
        fontFamily:fonts.fontFamily,
       color: '#8181A5',
    },
    subtitle: {
        fontFamily:fonts.fontFamily,
    },
};

interface DetailsBoxProps{
    title:string;
    subtitle:any;
}

function DetailBox ({title,subtitle}:DetailsBoxProps) {
    return (
        <Box style={styles.box}>
            <Typography style={styles.title} sx={{ fontSize: "0.75em" }}>
                {title}
            </Typography>
            <Typography style={styles.subtitle} sx={{ fontSize: "0.75em" }}>
                {subtitle}
            </Typography>
        </Box>
    );
}

export default withStyles(styles)(DetailBox);
